import React from "react";
import { Box } from "@mui/material";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        flexDirection: { xs: "column", md: "row" },
      }}
    >
      <Box
        sx={{
          flex: 1,
          position: "relative",
          minHeight: { xs: "40vh", md: "100vh" },
          backgroundImage: "url(/layout.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "2rem",
            left: "2rem",
          }}
        >
          <Box
            component="img"
            src="/Prowess_logo.png"
            alt="Logo"
            sx={{
              height: "6rem",
              width: "auto",
            }}
          />
        </Box>
      </Box>

      <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          bgcolor: "white",
          p: { xs: "1rem", md: "1.5rem" },
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "22rem",
            boxShadow: 3,
            borderRadius: "0.75rem",
            p: { xs: "1.5rem", md: "1.75rem" },
            bgcolor: "background.paper",
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
